/**
 * Inter se pide como fuente variable (un solo archivo para todos los pesos)
 * y de Barlow Condensed solo los dos pesos que la página realmente usa.
 */
const FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@700;900&family=Inter:wght@400..800&display=swap'

/**
 * Carga las fuentes de Google sin bloquear el renderizado inicial.
 * El truco de media="print" + onload="all" hace que el navegador descargue
 * la hoja de estilos fuera de la ruta crítica y la aplique al terminar.
 */
export function loadFonts(): void {
  if (typeof document === 'undefined') return
  if (document.querySelector('link[data-fonts="google"]')) return

  const preconnects: Array<{ href: string; crossOrigin?: string }> = [
    { href: 'https://fonts.googleapis.com' },
    { href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
  ]

  preconnects.forEach(({ href, crossOrigin }) => {
    const link = document.createElement('link')
    link.rel = 'preconnect'
    link.href = href
    if (crossOrigin) link.crossOrigin = crossOrigin
    document.head.appendChild(link)
  })

  const stylesheet = document.createElement('link')
  stylesheet.rel = 'stylesheet'
  stylesheet.href = FONTS_HREF
  stylesheet.media = 'print'
  stylesheet.dataset.fonts = 'google'
  stylesheet.addEventListener('load', () => {
    stylesheet.media = 'all'
  })
  document.head.appendChild(stylesheet)
}
